import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const IncentivesRoute = lazyWithRetries(() => import('./'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.incentives(),
    element: (
      <StandardPageLayout
        elementId="incentivesRoute"
        title={<T _str="Incentives" />}
        maxWidth={1080}>
        <Suspense fallback={<RouteLoading />}>
          <IncentivesRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
